/**
 * 将餐厅营业分析数据源接口错误映射为用户可读的国际化 key。
 * @param error - 接口响应或请求拦截器规范化后的错误对象。
 * @returns 双隧道校验错误的专用提示 key，其他情况返回通用保存失败 key。
 */
export function mapRestaurantOriginErrorToI18nKey(error: unknown): string {
    if (!error || typeof error !== 'object') {
        return 'dish_book_msg_save_failed';
    }

    /** 后端错误详情可能位于 result.details 或对象形式的 error.details。 */
    const payload = error as {
        error?: boolean | { details?: unknown };
        result?: { details?: unknown };
    };
    /** 请求拦截器可能包装后的对象形式错误。 */
    const nestedError = typeof payload.error === 'object' && payload.error !== null
        ? payload.error
        : undefined;
    /** 用于匹配业务校验原因的后端详情。 */
    const details = payload.result?.details ?? nestedError?.details;

    if (
        typeof details === 'string'
        && details.includes('Restaurant database_port must be an array')
        && details.includes('cloud_analysis_origin')
    ) {
        return 'settings_page_text_cloud_analysis_origin_dual_tunnel_required';
    }

    return 'dish_book_msg_save_failed';
}
